import React, { Component } from 'react';
import './ForecastByMunicipalities.css';
import en from '../../../../language/en/ForecastByMunicipalities.json';
import es from '../../../../language/es/ForecastByMunicipalities.json';
import map from './scu_map.svg';
import { Avatar, Container, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
/* Recharts */
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, BarChart, Bar } from 'recharts';
import config from '../../../../config/config.json';

//import request from '../../utils/Ajax/Request.js';
// import {Donut} from 'react-dial-knob';
// import { Knob, Arc, Pointer, Value } from 'rc-knob';
// import Knob from 'react-canvas-knob';

class ForecastByMunicipalities extends Component {
	constructor() {
		super();
		this.state = {
			pronMun: {//para la fecha actual
				1: {
					//1
				},
				"2": {
					//2
				},
				"3": {
					//3
				},
				4: {
					//4
				},
				"5": {
					//5
				},
				"6": {
					//6
				},
				"7": {
					//7
				},
				"8": {
					//8
				},
				"9": {
					//9
				}
			},
			fade: 'fade-in',
			config: {
				lang: {
					en: en,
					es: es
				}
			},
			// fullScreen: 'rounded-small',
			// showFullScreen: false,

			firstVarMun: 'tempMax',
			secondVarMun: 'tempMin',
			thirdVarMun: 'tempAmb',
			separatorVarMun: '/',
			UMfirstVarMun: 'º',//unidad de medida
			UMSecondVarMun: 'º',
			currentVarIcon: {
				stgo: '',
				guama: '',
				songoMaya: '',
				sanLuis: '',
				palma: '',
				iiiF: '',
				contre: '',
				mella: '',
				iiF: ''
			}
			/*
			'tempMin',
			'tempMax',
			'tempAmb',
			'sConfort',
			'humedad',
			'presion',
			'precipitaciones',
			'vientoMin',
			'vientoMax',
			'dir_viento',
			'nubosidad',
			'visibilidad'
			*/,
			widthOfLineChart: window.screen.width - 100,
		};

		// window.scrollTo(0, 1);
	}

	componentDidMount() {
		//Obteniendo el pronóstico por municipios
		const url = `${config.apiBaseUrl}/pronostico/prontodosmun`;
		fetch(url)
			.then(
				res => {
					return res.json();
				}
			)
			.then(
				data => {
					//console.log('data = ', data);
					let pronMunTemp = {
						1: (data[1]) ? data[1] : {},
						2: (data[2]) ? data[2] : {},
						3: (data[3]) ? data[3] : {},
						4: (data[4]) ? data[4] : {},
						5: (data[5]) ? data[5] : {},
						6: (data[6]) ? data[6] : {},
						7: (data[7]) ? data[7] : {},
						8: (data[8]) ? data[8] : {},
						9: (data[9]) ? data[9] : {}
					};

					this.setState({
						pronMun: pronMunTemp
						//pronMun: data
					}, () => this.showVar('default'));
					// console.log('pronMun= ', this.state.pronMun);
					/*console.log(this.state.pronMun[1]);
					console.log(this.state.pronMun[1].tempAmb);
					console.log(this.state.pronMun[1].nubosidad);*/
				}
			)
			.catch(
				err => {
					console.log("error ", err);
				}
			);

		//this.showVar('default');



		// this.setState({widthOfLineChart: window.screen.width - 100});

		window.scrollTo(0, 1);
	}

	showVar(typeOfVar) {

		// console.log('typeOfVar --> ', typeOfVar);		

		let pronMun = this.state.pronMun;
		switch (typeOfVar) {
			case 'default':
				this.setState({
					firstVarMun: 'tempMax',
					secondVarMun: 'tempMin',
					thirdVarMun: 'tempAmb',
					separatorVarMun: '/',
					UMfirstVarMun: 'º',
					UMSecondVarMun: 'º',
					currentVarIcon: {
						stgo: (pronMun[1].nubosidad) ? this.loadIcon('nubosidad', pronMun[1].nubosidad) : '',
						guama: (pronMun[2].nubosidad) ? this.loadIcon('nubosidad', pronMun[2].nubosidad) : '',
						songoMaya: (pronMun[3].nubosidad) ? this.loadIcon('nubosidad', pronMun[3].nubosidad) : '',
						sanLuis: (pronMun[4].nubosidad) ? this.loadIcon('nubosidad', pronMun[4].nubosidad) : '',
						palma: (pronMun[5].nubosidad) ? this.loadIcon('nubosidad', pronMun[5].nubosidad) : '',
						iiiF: (pronMun[6].nubosidad) ? this.loadIcon('nubosidad', pronMun[6].nubosidad) : '',
						contre: (pronMun[7].nubosidad) ? this.loadIcon('nubosidad', pronMun[7].nubosidad) : '',
						mella: (pronMun[8].nubosidad) ? this.loadIcon('nubosidad', pronMun[8].nubosidad) : '',
						iiF: (pronMun[9].nubosidad) ? this.loadIcon('nubosidad', pronMun[9].nubosidad) : '',
					}
				});
				break;

			case 'temp':
				this.setState({
					firstVarMun: 'tempMax',
					secondVarMun: 'tempMin',
					thirdVarMun: 'tempAmb',
					separatorVarMun: '/',
					UMfirstVarMun: 'º',
					UMSecondVarMun: 'º',
					currentVarIcon: {
						stgo: (pronMun[1].tempAmb) ? this.loadIcon('temp', pronMun[1].tempAmb) : '', // (variable, valor)
						guama: (pronMun[2].tempAmb) ? this.loadIcon('temp', pronMun[2].tempAmb) : '',
						songoMaya: (pronMun[3].tempAmb) ? this.loadIcon('temp', pronMun[3].tempAmb) : '',
						sanLuis: (pronMun[4].tempAmb) ? this.loadIcon('temp', pronMun[4].tempAmb) : '',
						palma: (pronMun[5].tempAmb) ? this.loadIcon('temp', pronMun[5].tempAmb) : '',
						iiiF: (pronMun[6].tempAmb) ? this.loadIcon('temp', pronMun[6].tempAmb) : '',
						contre: (pronMun[7].tempAmb) ? this.loadIcon('temp', pronMun[7].tempAmb) : '',
						mella: (pronMun[8].tempAmb) ? this.loadIcon('temp', pronMun[8].tempAmb) : '',
						iiF: (pronMun[9].tempAmb) ? this.loadIcon('temp', pronMun[9].tempAmb) : ''
					}
				});
				break;

			case 'nivelConfort':
				this.setState({
					firstVarMun: 'humedad',
					secondVarMun: 'sConfort',
					thirdVarMun: '',
					separatorVarMun: <br />,
					UMfirstVarMun: ' %',
					UMSecondVarMun: 'º',
					currentVarIcon: {
						stgo: '',
						guama: '',
						songoMaya: '',
						sanLuis: '',
						palma: '',
						iiiF: '',
						contre: '',
						mella: '',
						iiF: ''
					}
				});
				break;
			//
			case 'presion':
				this.setState({
					firstVarMun: 'presion',
					secondVarMun: '',
					thirdVarMun: '',
					separatorVarMun: '',
					UMfirstVarMun: ' hPa',
					UMSecondVarMun: '',
					currentVarIcon: {
						stgo: (pronMun[1].presion) ? this.loadIcon('presion', pronMun[1].presion) : '', // (variable, valor)
						guama: (pronMun[2].presion) ? this.loadIcon('presion', pronMun[2].presion) : '',
						songoMaya: (pronMun[3].presion) ? this.loadIcon('presion', pronMun[3].presion) : '',
						sanLuis: (pronMun[4].presion) ? this.loadIcon('presion', pronMun[4].presion) : '',
						palma: (pronMun[5].presion) ? this.loadIcon('presion', pronMun[5].presion) : '',
						iiiF: (pronMun[6].presion) ? this.loadIcon('presion', pronMun[6].presion) : '',
						contre: (pronMun[7].presion) ? this.loadIcon('presion', pronMun[7].presion) : '',
						mella: (pronMun[8].presion) ? this.loadIcon('presion', pronMun[8].presion) : '',
						iiF: (pronMun[9].presion) ? this.loadIcon('presion', pronMun[9].presion) : ''
					}
				});
				break;

			case 'precipitaciones':
				this.setState({
					firstVarMun: 'precipitaciones',
					secondVarMun: '',
					thirdVarMun: '',
					separatorVarMun: '',
					UMfirstVarMun: '',
					UMSecondVarMun: '',
					currentVarIcon: {
						stgo: (pronMun[1].precipitaciones) ? this.loadIcon('precipitaciones', pronMun[1].precipitaciones) : '',
						guama: (pronMun[2].precipitaciones) ? this.loadIcon('precipitaciones', pronMun[2].precipitaciones) : '',
						songoMaya: (pronMun[3].precipitaciones) ? this.loadIcon('precipitaciones', pronMun[3].precipitaciones) : '',
						sanLuis: (pronMun[4].precipitaciones) ? this.loadIcon('precipitaciones', pronMun[4].precipitaciones) : '',
						palma: (pronMun[5].precipitaciones) ? this.loadIcon('precipitaciones', pronMun[5].precipitaciones) : '',
						iiiF: (pronMun[6].precipitaciones) ? this.loadIcon('precipitaciones', pronMun[6].precipitaciones) : '',
						contre: (pronMun[7].precipitaciones) ? this.loadIcon('precipitaciones', pronMun[7].precipitaciones) : '',
						mella: (pronMun[8].precipitaciones) ? this.loadIcon('precipitaciones', pronMun[8].precipitaciones) : '',
						iiF: (pronMun[9].precipitaciones) ? this.loadIcon('precipitaciones', pronMun[9].precipitaciones) : '',
					}
				});
				break;

			case 'viento':
				this.setState({
					firstVarMun: 'vientoMin',
					secondVarMun: 'vientoMax',
					thirdVarMun: 'dir_viento',
					separatorVarMun: '-',
					UMfirstVarMun: '',
					UMSecondVarMun: ' km/h',
					currentVarIcon: {
						stgo: (pronMun[1].dir_viento) ? this.loadIcon('viento', pronMun[1].dir_viento) : '',
						guama: (pronMun[2].dir_viento) ? this.loadIcon('viento', pronMun[2].dir_viento) : '',
						songoMaya: (pronMun[3].dir_viento) ? this.loadIcon('viento', pronMun[3].dir_viento) : '',
						sanLuis: (pronMun[4].dir_viento) ? this.loadIcon('viento', pronMun[4].dir_viento) : '',
						palma: (pronMun[5].dir_viento) ? this.loadIcon('viento', pronMun[5].dir_viento) : '',
						iiiF: (pronMun[6].dir_viento) ? this.loadIcon('viento', pronMun[6].dir_viento) : '',
						contre: (pronMun[7].dir_viento) ? this.loadIcon('viento', pronMun[7].dir_viento) : '',
						mella: (pronMun[8].dir_viento) ? this.loadIcon('viento', pronMun[8].dir_viento) : '',
						iiF: (pronMun[9].dir_viento) ? this.loadIcon('viento', pronMun[9].dir_viento) : '',
					}
				});
				break;

			case 'nubosidad':
				this.setState({
					firstVarMun: 'nubosidad',
					secondVarMun: '',
					thirdVarMun: '',
					separatorVarMun: '',
					UMfirstVarMun: '',
					UMSecondVarMun: '',
					currentVarIcon: {
						stgo: (pronMun[1].nubosidad) ? this.loadIcon('nubosidad', pronMun[1].nubosidad) : '',
						guama: (pronMun[2].nubosidad) ? this.loadIcon('nubosidad', pronMun[2].nubosidad) : '',
						songoMaya: (pronMun[3].nubosidad) ? this.loadIcon('nubosidad', pronMun[3].nubosidad) : '',
						sanLuis: (pronMun[4].nubosidad) ? this.loadIcon('nubosidad', pronMun[4].nubosidad) : '',
						palma: (pronMun[5].nubosidad) ? this.loadIcon('nubosidad', pronMun[5].nubosidad) : '',
						iiiF: (pronMun[6].nubosidad) ? this.loadIcon('nubosidad', pronMun[6].nubosidad) : '',
						contre: (pronMun[7].nubosidad) ? this.loadIcon('nubosidad', pronMun[7].nubosidad) : '',
						mella: (pronMun[8].nubosidad) ? this.loadIcon('nubosidad', pronMun[8].nubosidad) : '',
						iiF: (pronMun[9].nubosidad) ? this.loadIcon('nubosidad', pronMun[9].nubosidad) : '',
					}
				});
				break;

			case 'visibilidad':
				this.setState({
					firstVarMun: 'visibilidad',
					secondVarMun: '',
					thirdVarMun: '',
					separatorVarMun: '',
					UMfirstVarMun: ' km',
					UMSecondVarMun: '',
					currentVarIcon: {
						stgo: (pronMun[1].visibilidad) ? this.loadIcon('visibilidad', pronMun[1].visibilidad) : '',
						guama: (pronMun[2].visibilidad) ? this.loadIcon('visibilidad', pronMun[2].visibilidad) : '',
						songoMaya: (pronMun[3].visibilidad) ? this.loadIcon('visibilidad', pronMun[3].visibilidad) : '',
						sanLuis: (pronMun[4].visibilidad) ? this.loadIcon('visibilidad', pronMun[4].visibilidad) : '',
						palma: (pronMun[5].visibilidad) ? this.loadIcon('visibilidad', pronMun[5].visibilidad) : '',
						iiiF: (pronMun[6].visibilidad) ? this.loadIcon('visibilidad', pronMun[6].visibilidad) : '',
						contre: (pronMun[7].visibilidad) ? this.loadIcon('visibilidad', pronMun[7].visibilidad) : '',
						mella: (pronMun[8].visibilidad) ? this.loadIcon('visibilidad', pronMun[8].visibilidad) : '',
						iiF: (pronMun[9].visibilidad) ? this.loadIcon('visibilidad', pronMun[9].visibilidad) : '',
					}
				});
				break;

			default:

				break;
		}
	}

	loadIcon(typeOfVar, valueOfVar) {
		// console.log('typeOfVar= ', typeOfVar);
		switch (typeOfVar) {
			case 'nubosidad':
				let nubosidadIcon;
				switch (valueOfVar) {
					case 'Despejado':
						nubosidadIcon = <div className="sun animated pulse infinite"></div>;
						break;
					case 'Poco Nublado':
						nubosidadIcon = <div className="mostly-suny">
							<div className="sun animated pulse infinite"></div>
							<div className="cloudy animated pulse infinite">
								<div className="shadow"></div>
							</div>
						</div>;
						break;
					case 'Parcialmente Nublado':
						nubosidadIcon = <div className="mostly-suny">
							<div className="sun animated pulse infinite" style={{ width: '50px', height: '50px' }}></div>
							<div className="hazy cloudy animated pulse infinite">
								<div className="shadow"></div>
							</div>
						</div>;
						break;
					case 'Nublado':
						nubosidadIcon = <div className="hazy cloudy animated pulse infinite">
							<div className="shadow"></div>
						</div>;
						break;
					default:
						break;
				}
				return nubosidadIcon;
				break;

			case 'temp':
				let tempIcon = <div type="text" id={'noui-temp' + valueOfVar} style={{ height: '120px' }} className="temp noUi-target noUi-rtl noUi-vertical noUi-background tooltips" data-original-title="Temperatura">
					<div className="noUi-base">
						<div className="noUi-origin noUi-connect noUi-draggable" style={{ top: 100 - valueOfVar + '%' }}></div>
					</div>
					<div className="noUi-pips noUi-pips-vertical">
						<div className="noUi-marker noUi-marker-vertical noUi-marker-large" style={{ top: '100%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-large" style={{ top: '100%' }}>0</div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '98%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '96%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '94%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '92%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-sub" style={{ top: '90%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-sub" style={{ top: '90%' }}>10</div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '88%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '86%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '84%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '82%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-sub" style={{ top: '80%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-sub" style={{ top: '80%' }}>20</div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '78%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '76%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '74%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '72%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-sub" style={{ top: '70%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-sub" style={{ top: '70%' }}>30</div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '68%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '66%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '64%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '62%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-sub" style={{ top: '60%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-sub" style={{ top: '60%' }}>40</div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '58%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '56%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '54%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '52%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-sub" style={{ top: '50%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-sub" style={{ top: '50%' }}>50</div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '48%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '46%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '44%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '42%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-sub" style={{ top: '40%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-sub" style={{ top: '40%' }}>60</div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '38%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '36%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '34%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '32%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-sub" style={{ top: '30%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-sub" style={{ top: '30%' }}>70</div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '28%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '26%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '24%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '22%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-sub" style={{ top: '20%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-sub" style={{ top: '20%' }}>80</div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '18%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '16%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '14%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '12%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-sub" style={{ top: '10%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-sub" style={{ top: '10%' }}>90</div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '8%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '6%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '4%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '2%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-large" style={{ top: '0%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-large" style={{ top: '0%' }}>100</div>
					</div>
				</div>;
				return tempIcon;
				break;

			case 'nivelConfort':

				break;

			case 'presion':
				let presionIcon = <div type="text" style={{ height: '120px' }} className="noUi-target noUi-rtl noUi-vertical noUi-background tooltips" data-original-title="Presión">
					<div className="noUi-base">
						<div className="noUi-origin noUi-connect noUi-draggable" style={{ top: -0.2 * valueOfVar + 220 + '%' }}></div>
					</div>
					<div className="noUi-pips noUi-pips-vertical">
						<div className="noUi-marker noUi-marker-vertical noUi-marker-large" style={{ top: '100%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-large" style={{ top: '100%' }}>600</div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '98%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '96%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '94%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '92%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-sub" style={{ top: '90%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-sub" style={{ top: '90%' }}>650</div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '88%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '86%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '84%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '82%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-sub" style={{ top: '80%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-sub" style={{ top: '80%' }}>700</div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '78%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '76%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '74%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '72%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-sub" style={{ top: '70%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-sub" style={{ top: '70%' }}>750</div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '68%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '66%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '64%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '62%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-sub" style={{ top: '60%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-sub" style={{ top: '60%' }}>800</div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '58%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '56%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '54%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '52%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-sub" style={{ top: '50%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-sub" style={{ top: '50%' }}>850</div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '48%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '46%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '44%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '42%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-sub" style={{ top: '40%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-sub" style={{ top: '40%' }}>900</div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '38%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '36%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '34%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '32%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-sub" style={{ top: '30%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-sub" style={{ top: '30%' }}>950</div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '28%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '26%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '24%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '22%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-sub" style={{ top: '20%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-sub" style={{ top: '20%' }}>1000</div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '18%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '16%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '14%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '12%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-sub" style={{ top: '10%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-sub" style={{ top: '10%' }}>1050</div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '8%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '6%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '4%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-normal" style={{ top: '2%' }}></div>
						<div className="noUi-marker noUi-marker-vertical noUi-marker-large" style={{ top: '0%' }}></div>
						<div className="noUi-value noUi-value-vertical noUi-value-large" style={{ top: '0%' }}>1100</div>
					</div>
				</div>;
				return presionIcon;
				break;

			case 'precipitaciones':
				let precipitacionesIcon;
				switch (valueOfVar) {
					case 'No lloverá':
						precipitacionesIcon = <div className="sun animated pulse infinite"></div>
						break;
					case 'Aisladas':
						precipitacionesIcon = <div className={valueOfVar + " tooltips"} data-original-title="Aisladas lluvias">
							<div className="sun animated pulse infinite"></div>
							<div className="rainy animated pulse infinite" style={{ marginTop: '-20px' }}>
								<div className="shadow"></div>
							</div>
							<div className="sub-wheather">
								<div className="rain">
									<div className="droplet droplet1"></div>
									<div className="droplet droplet2"></div>
									<div className="droplet droplet3"></div>
									<div className="droplet droplet4"></div>
									<div className="droplet droplet5"></div>
									<div className="droplet droplet6"></div>
								</div>
							</div>
						</div>
						break;
					case 'Algunos':
						precipitacionesIcon = <div className={valueOfVar + " tooltips"} data-original-title="Algunas lluvias">
							<div className="sun animated pulse infinite" style={{ margin: '0', width: '45px', height: '45px' }}></div>
							<div className="rainy animated pulse infinite" style={{ marginTop: '-20px' }}>
								<div className="shadow"></div>
							</div>
							<div className="sub-wheather">
								<div className="rain">
									<div className="droplet droplet1"></div>
									<div className="droplet droplet2"></div>
									<div className="droplet droplet3"></div>
									<div className="droplet droplet4"></div>
									<div className="droplet droplet5"></div>
									<div className="droplet droplet6"></div>
								</div>
							</div>
						</div>
						break;
					case 'Numerosas':
						precipitacionesIcon = <div className={valueOfVar + " tooltips"} data-original-title="Numerosas">
							<div className="hazy rainy animated pulse infinite" style={{}}>
								<div className="shadow"></div>
							</div>
							<div className="sub-wheather">
								<div className="rain">
									<div className="droplet droplet1"></div>
									<div className="droplet droplet2"></div>
									<div className="droplet droplet3"></div>
									<div className="droplet droplet4"></div>
									<div className="droplet droplet5"></div>
									<div className="droplet droplet6"></div>
								</div>
							</div>
						</div>
						break;
					case 'Intensas':
						precipitacionesIcon = <div className={valueOfVar + " tooltips"} data-original-title="Intensas">
							<div className="stormy rainy animated pulse infinite" style={{}}>
								<div className="shadow"></div>
							</div>
							<div className="sub-wheather">
								<div className="rain">
									<div className="droplet droplet1"></div>
									<div className="droplet droplet2"></div>
									<div className="droplet droplet3"></div>
									<div className="droplet droplet4"></div>
									<div className="droplet droplet5"></div>
									<div className="droplet droplet6"></div>
								</div>
							</div>
						</div>
						break;
					case 'Intensas con (TE)':
						precipitacionesIcon = <div className={valueOfVar + " tooltips"} data-original-title="Intensas con (TE)">
							<div className="stormy rainy animated pulse infinite" style={{}}>
								<div className="shadow"></div>
							</div>
							<div className="sub-wheather">
								<div className="thunder"></div>
								<div className="rain">
									<div className="droplet droplet1"></div>
									<div className="droplet droplet2"></div>
									<div className="droplet droplet3"></div>
									<div className="droplet droplet4"></div>
									<div className="droplet droplet5"></div>
									<div className="droplet droplet6"></div>
								</div>
							</div>
						</div>
						break;
					case 'Intensas con algunos granizos':
						precipitacionesIcon = <div className={valueOfVar + " tooltips"} data-original-title="Intensas con granizos">
							<div className="stormy rainy animated pulse infinite">
								<div className="shadow"></div>
							</div>
							<div className="sub-wheather">
								<div className="rain">
									<div className="droplet droplet1"></div>
									<div className="droplet droplet2"></div>
									<div className="droplet droplet4"></div>
									<div className="droplet droplet5"></div>
								</div>
							</div>
							<div className="sub-wheather snowy-sub-wheather" style={{ marginTop: '-100px' }}>
								<div className="rain">
									<div className="droplet droplet3"></div>
									<div className="droplet droplet6"></div>
								</div>
							</div>
						</div>
						break;
					case 'Lluvia de granizos':
						precipitacionesIcon = <div className={valueOfVar + " tooltips"} data-original-title="Lluvia de granizos">
							<div className="snowy rainy animated pulse infinite" style={{}}>
								<div className="shadow"></div>
							</div>
							<div className="sub-wheather snowy-sub-wheather">
								<div className="rain">
									<div className="droplet droplet1"></div>
									<div className="droplet droplet2"></div>
									<div className="droplet droplet3"></div>
									<div className="droplet droplet4"></div>
									<div className="droplet droplet5"></div>
									<div className="droplet droplet6"></div>
								</div>
							</div>
						</div>
						break;

					default:
						break;
				}
				return precipitacionesIcon;
				break;

			case 'viento':
				return <img src={"/resources/img/Weather_3D/wind_" + valueOfVar + ".png"} className="tooltips" data-original-title={valueOfVar} style={{ cursor: 'pointer', marginTop: '20px', marginLeft: '44px' }} />
				break;

			case 'visibilidad':

				break;

			default:

				break;
		}
	}

	render() {
		const lang = this.state.config.lang;
		const selectedLanguage = (this.props.lang === 'en') ? lang.en : lang.es;

		const pronStgo = this.state.pronMun[1];
		const pronGuama = this.state.pronMun[2];
		const pronMaya = this.state.pronMun[3];
		const pronSanLuis = this.state.pronMun[4];
		const pronPalma = this.state.pronMun[5];
		const pronIIIF = this.state.pronMun[6];
		const pronContre = this.state.pronMun[7];
		const pronMella = this.state.pronMun[8];
		const pronIIF = this.state.pronMun[9];

		const firstVar = this.state.firstVarMun;
		const secondVar = this.state.secondVarMun;
		const thirdVar = this.state.thirdVarMun;
		const separatorVar = this.state.separatorVarMun;
		const UMfirstVar = this.state.UMfirstVarMun;
		const UMSecondVar = this.state.UMSecondVarMun;
		const iconVar = this.state.iconVarMun;

		let rows = [
			{ valor1: 'Temp mín', valor2: 'un valor', valor3: 'otro valor', valor4: 'y otro', valor5: 'y otro', valor6: 'y otro', valor7: 'y otro', valor8: '...', valor9: '...' },
		];

		return (
			<section id="forecast" lang={this.props.lang}>
				<div className="heading">
					<Typography variant="h4" color="secondary" className="efecto-espejo">
						{selectedLanguage.sectionTitle}
					</Typography>
				</div>
				<div className={'forecast ' + this.state.fade}>
					<div className="container">
						<Typography variant="h6" color="textSecondary" align="center" id="fecha">
							Fecha: {pronStgo.fecha ? pronStgo.fecha.split('-').join('/') : 'dd/mm/yyyy'}
						</Typography>
						{/* <a className="btn btn-circle blue-hoki btn-sm tooltips" data-container="body" data-placement="top" data-original-title="Close forecast section" style={{ float: 'right'}} onClick={ () => {this.setState({fade: 'fade-out'}); this.props.in(false, 5);} }>
				      	<i className="fa fa-times"/>
				      </a> */}

						<div className="row">

							<div className="col-md-12" id="map-wrapper">

								<div className="form-horizontal col-md-4" style={{ /* position: 'absolute', */ zIndex: '1' }}>
									<div className="row">
										<div className="col-xs-2">
											<label className="form-control bg-map" style={{ paddingTop: '13px' }}>Ver</label>
										</div>
										<div className="col-xs-10">
											<select className="form-control" onChange={e => { e.preventDefault(); this.showVar(e.target.value); }}>
												<option value="default">Valores por defecto</option>
												<option value="temp">Temperatura</option>
												<option value="nivelConfort">Nivel de Confort</option>
												<option value="presion">Presión</option>
												<option value="precipitaciones">Precipitaciones</option>
												<option value="viento">Viento</option>
												<option value="nubosidad">Nubosidad</option>
												<option value="visibilidad">Visibilidad</option>
											</select>
										</div>
									</div>
								</div>
								<div id="meteorologo" className="col-sm-4 col-xs-11">
									<Typography variant="h5">
										Meteorólogo:
									</Typography>
									<div className="row">
										<div className="col-sm-12">
											<Avatar alt={pronStgo.meteorologo} src={`assets/files/avatar/gpmm/${pronStgo.meteorologo}.png`} className="big-avatar" />
										</div>
									</div>
									<div className="row">
										<div className="col-sm-12">
											<strong>
												<h4>{pronStgo.meteorologo}</h4>
											</strong>
										</div>
									</div>
								</div>

								{/* <div style={{ position: 'absolute', top: '99px', left: '45px', zIndex: '1' }}>
									<h4>Humedad</h4>
									<input className="knob" data-angleoffset="-125" data-anglearc="250" data-fgcolor="#3598dc" defaultValue={pronStgo['humedad']} data-width="100" />

								</div> */}

								<embed src={map} alt="map" className="mapa" />

								<div id="santiago">
									<div className="var-icon">
										{this.state.currentVarIcon.stgo}
									</div>

									<div className="var-muncp">
										{/* <strong className="first-var" style={{ display: 'block', fontSize: '2rem' }}>
											{pronStgo[thirdVar]}
											{(pronStgo[thirdVar]) ? UMfirstVar : ''}
										</strong> */}
										<strong className="first-var">
											{pronStgo[firstVar]}
											{(pronStgo[firstVar]) ? UMfirstVar : ''}
										</strong>
										<span className="second-var">
											{(pronStgo[secondVar]) ? separatorVar : ''}
											{pronStgo[secondVar]}
											{(pronStgo[secondVar]) ? UMSecondVar : ''}
										</span>
									</div>
								</div>

								<div id="guama">
									<div className="var-icon">
										{this.state.currentVarIcon.guama}
									</div>

									<div className="var-muncp">
										<strong className="first-var">
											{pronGuama[firstVar]}
											{(pronGuama[firstVar]) ? UMfirstVar : ''}
										</strong>
										<span className="second-var">
											{(pronGuama[secondVar]) ? separatorVar : ''}
											{pronGuama[secondVar]}
											{(pronGuama[secondVar]) ? UMSecondVar : ''}
										</span>
									</div>
								</div>

								<div id="songo-maya">
									<div className="var-icon">
										{this.state.currentVarIcon.songoMaya}
									</div>

									<div className="var-muncp">
										<strong className="first-var">
											{pronMaya[firstVar]}
											{(pronMaya[firstVar]) ? UMfirstVar : ''}
										</strong>
										<span className="second-var">
											{(pronMaya[secondVar]) ? separatorVar : ''}
											{pronMaya[secondVar]}
											{(pronMaya[secondVar]) ? UMSecondVar : ''}
										</span>
									</div>
								</div>

								<div id="san-luis">
									<div className="var-icon">
										{this.state.currentVarIcon.sanLuis}
									</div>

									<div className="var-muncp">
										<strong className="first-var">
											{pronSanLuis[firstVar]}
											{(pronSanLuis[firstVar]) ? UMfirstVar : ''}
										</strong>
										<span className="second-var">
											{(pronSanLuis[secondVar]) ? separatorVar : ''}
											{pronSanLuis[secondVar]}
											{(pronSanLuis[secondVar]) ? UMSecondVar : ''}
										</span>
									</div>
								</div>

								<div className="wheather" id="palma">
									<div className="var-icon">
										{this.state.currentVarIcon.palma}
									</div>

									<div className="var-muncp">
										<strong className="first-var">
											{pronPalma[firstVar]}
											{(pronPalma[firstVar]) ? UMfirstVar : ''}
										</strong>
										<span className="second-var">
											{(pronPalma[secondVar]) ? separatorVar : ''}
											{pronPalma[secondVar]}
											{(pronPalma[secondVar]) ? UMSecondVar : ''}
										</span>
									</div>
								</div>

								<div id="iii-frente">
									<div className="var-icon">
										{this.state.currentVarIcon.iiiF}
									</div>

									<div className="var-muncp">
										<strong className="first-var">
											{pronIIIF[firstVar]}
											{(pronIIIF[firstVar]) ? UMfirstVar : ''}
										</strong>
										<span className="second-var">
											{(pronIIIF[secondVar]) ? separatorVar : ''}
											{pronIIIF[secondVar]}
											{(pronIIIF[secondVar]) ? UMSecondVar : ''}
										</span>
									</div>
								</div>

								<div id="contre">
									<div className="var-icon">
										{this.state.currentVarIcon.contre}
									</div>

									<div className="var-muncp">
										<strong className="first-var">
											{pronContre[firstVar]}
											{(pronContre[firstVar]) ? UMfirstVar : ''}
										</strong>
										<span className="second-var">
											{(pronContre[secondVar]) ? separatorVar : ''}
											{pronContre[secondVar]}
											{(pronContre[secondVar]) ? UMSecondVar : ''}
										</span>
									</div>
								</div>

								<div id="mella">
									<div className="var-icon">
										{this.state.currentVarIcon.mella}
									</div>

									<div className="var-muncp">
										<strong className="first-var">
											{pronMella[firstVar]}
											{(pronMella[firstVar]) ? UMfirstVar : ''}
										</strong>
										<span className="second-var">
											{(pronMella[secondVar]) ? separatorVar : ''}
											{pronMella[secondVar]}
											{(pronMella[secondVar]) ? UMSecondVar : ''}
										</span>
									</div>
								</div>

								<div id="ii-frente">
									<div className="var-icon">
										{this.state.currentVarIcon.iiF}
									</div>

									<div className="var-muncp">
										<strong className="first-var">
											{pronIIF[firstVar]}
											{(pronIIF[firstVar]) ? UMfirstVar : ''}
										</strong>
										<span className="second-var">
											{(pronIIF[secondVar]) ? separatorVar : ''}
											{pronIIF[secondVar]}
											{(pronIIF[secondVar]) ? UMSecondVar : ''}
										</span>
									</div>
								</div>

							</div>

						</div>
					</div>
				</div>



				<Container maxWidth="xl" style={{ marginBottom: '50px' }}>
					<Grid
						container
						spacing={1}
						direction="column"
						justify="flex-start"
						alignItems="center"
						alignContent="stretch"
						wrap="nowrap"

					>
						<Typography variant="subtitle1" color="textSecondary" align="center" style={{ margin: '50px 0 8px' }}>
							Gráfico: Comportamiento de la temperatura por municipios.
						</Typography>
						{/* Charts */}
						<Paper elevation={4}>
							<LineChart width={this.state.widthOfLineChart} height={200} data={Object.values(this.state.pronMun)} >
								<CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
								<XAxis dataKey="municipio" />
								<YAxis />
								<Tooltip />
								<Legend />
								<Line type="monotone" dataKey="tempMax" stroke="#f33" />
								<Line type="natural" dataKey="tempAmb" stroke="#304151" />
								<Line type="monotoneX" dataKey="tempMin" stroke="#33f" />
							</LineChart>
						</Paper>

						<Typography variant="subtitle1" color="textSecondary" align="center" style={{ margin: '50px 0 8px' }}>
							Gráfico: Comportamiento del viento por municipios.
						</Typography>
						{/* Charts */}
						<Paper elevation={4}>
							<LineChart width={this.state.widthOfLineChart} height={200} data={Object.values(this.state.pronMun)} >
								<CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
								<XAxis dataKey="municipio" />
								<YAxis />
								<Tooltip />
								<Legend />
								<Line type="monotone" dataKey="vientoMax" stroke="#f33" />
								<Line type="monotoneX" dataKey="vientoMin" stroke="#33f" />
							</LineChart>
						</Paper>

						<Typography variant="subtitle1" color="textSecondary" align="center" style={{ margin: '50px 0 8px' }}>
							Gráficos: Comportamiento de la humedad y la presion por municipios.
						</Typography>
						<Grid
							container
							spacing={1}
							direction="row"
							justify="center"
							alignItems="flex-start"
							alignContent="stretch"
							wrap="nowrap"

						>
							<Grid item>
								<Paper elevation={4}>
									<BarChart width={this.state.widthOfLineChart / 2} height={200} data={Object.values(this.state.pronMun)} >
										<CartesianGrid stroke="#ccc" strokeDasharray="3 3" />
										<XAxis dataKey="municipio" />
										<YAxis />
										<Tooltip />
										<Legend />
										<Bar dataKey="presion" fill="#3FB8AFaa" />
									</BarChart>
								</Paper>
							</Grid>

							<Grid item>
								<Paper elevation={4}>
									<BarChart width={this.state.widthOfLineChart / 2} height={200} data={Object.values(this.state.pronMun)} >
										<CartesianGrid stroke="#ccc" strokeDasharray="3 3" />
										<XAxis dataKey="municipio" />
										<YAxis />
										<Tooltip />
										<Legend />
										<Bar dataKey="humedad" fill="#1976d2aa" />
									</BarChart>
								</Paper>
							</Grid>

						</Grid>


					</Grid>
				</Container>


				{/* <Grid
					container
					spacing={1}
					direction="row"
					justify="center"
					alignItems="flex-start"
					alignContent="stretch"
					wrap="nowrap"

				>
					<TableContainer component={Paper} style={{ maxWidth: '90%' }}>
						<Typography style={{ fontWeight: 'bold' }} variant="subtitle1" color="textPrimary" align="center" >
							Variables Pronosticadas
									</Typography>
						<Table stickyHeader aria-label="simple table" size="small">
							<TableHead>
								<TableRow>
									<TableCell>stgo</TableCell>
									<TableCell align="center">guama</TableCell>
									<TableCell align="center">san luis</TableCell>
									<TableCell align="center">songo la maya</TableCell>
									<TableCell align="center">II frente</TableCell>
									<TableCell align="center">III frnte</TableCell>
									<TableCell align="center">palma</TableCell>
									<TableCell align="center">contramaestre</TableCell>
									<TableCell align="right">mella</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{rows.map((row) => (
									<TableRow key={row.valor1}>
										<TableCell component="th" scope="row">
											{row.valor1}
										</TableCell>
										<TableCell align="center">{row.valor2}</TableCell>
										<TableCell align="center">{row.valor3}</TableCell>
										<TableCell align="center">{row.valor4}</TableCell>
										<TableCell align="center">{row.valor5}</TableCell>
										<TableCell align="center">{row.valor6}</TableCell>
										<TableCell align="center">{row.valor7}</TableCell>
										<TableCell align="center">{row.valor8}</TableCell>
										<TableCell align="right">{row.valor9}</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				</Grid>
 */}
			</section>

		);
	}
}

export default ForecastByMunicipalities;